import { Flex } from 'antd';
import { cn } from '../lib/cn';

type Props = {
  text?: string;
  className?: string;
};

export default function TruncateText({ text, className }: Props) {
  if (!text) {
    return null;
  }

  return (
    <Flex align="center" gap={0} className={cn('max-w-[200px]', className)}>
      {/* Truncated filename part */}
      <span className="truncate block">{text.replace(/\.[^/.]+$/, '')}</span>

      {/* Full extension */}
      <span className="flex-shrink-0">{text.match(/\.[^/.]+$/)?.[0]}</span>
    </Flex>
  );
}
